import ChannelDetail from './ChannelDetail';

export default ChannelDetail;